import { baseApi } from './baseApi';
// Define a local user profile type to avoid referencing non-exported types
export interface UserProfile {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  city: number;
  state: number;
  country: number;
  role_id: string;
  createdAt: string;
  updatedAt: string;
  deleteAt: null | string;
  access: string;
  role_name: string;
  org_id: string | null;
  sub_org_id: string | null;
  patient_id: string;
  sabai_status?: boolean | string | null;
  city_name?: string;
  state_name?: string;
  country_name?: string;
}

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query<UserProfile, string>({
      query: (id) => ({
        url: `/user/getUser/${id}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetUserQuery } = userApi;
